export { ForwardComponent } from './forward.component';
export { ForwardModule } from './forward.module';
